// Wraps markdown-it loaded via CDN. Falls back to escaped text if not yet loaded.

let instance: { render(md: string): string } | null = null;

function escape(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function renderMarkdown(md: string): string {
  if (!instance && typeof window !== "undefined" && typeof window.markdownit === "function") {
    instance = window.markdownit();
  }
  if (instance) return instance.render(md);
  return `<p>${escape(md).replace(/\n/g, "<br>")}</p>`;
}
